export default __webpack_public_path__ + "icon_cloud.acbe973b60ac66b2386ed594da97cf7c.svg";